import { cookieProfil } from "./cookieProfil";

export const eventProject = () => {
    const sections = document.querySelectorAll('section.block') as NodeListOf<HTMLElement>;
    sections.forEach(section => {
        const buttons = section.querySelectorAll('a.btn') as NodeListOf<HTMLElement>;
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const url = button.getAttribute("href");
                if (url && url.includes("/demandez-un-devis")) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'Etape0',
                        emplacementCTA: 'page'
                    });
                }
            });
        });
    });

    const header = document.querySelector('header');
    if (header) {
        const buttons = header.querySelectorAll('.cta-project') as NodeListOf<HTMLElement>;
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'Etape0',
                    emplacementCTA: 'banner'
                });
            });
        });
    }

    const projectPage = document.querySelector('.template-request-quote');
    if (!projectPage) return;

    const steps = projectPage.querySelectorAll('form .gform_page') as NodeListOf<HTMLElement>;
    steps.forEach(step => {
        const stepNumber = document.querySelector('.gf_step_active .gf_step_number')?.textContent?.trim();
        if (!stepNumber) return;

        // Click next buttons.
        const nextButton = step.querySelector('[data-submission-type="next"]');
        nextButton?.addEventListener('click', () => {

            if (stepNumber === '1') {
                const input = step.querySelector<HTMLInputElement>('.gfield-choice-input:checked')?.value || 'na';

                // Set cookie profil.
                cookieProfil.setCookie('profil', input, 30);

                window.dataLayer.push({
                    event: 'Etape1',
                    profil: input,
                });
            } else if (stepNumber === '2') {
                const inputs = step.querySelectorAll<HTMLInputElement>('.gfield-choice-input:checked');
                const values = Array.from(inputs, input => input.value);
                window.dataLayer.push({
                    event: 'Etape2',
                    nomBesoin: values.length ? values.join(', ') : 'na',
                });
            } else if (stepNumber === '3') {
                const input_phase = step.querySelector<HTMLInputElement>('.gfield.phase input:checked')?.value || 'na';
                const input_launch_deadline = step.querySelector<HTMLInputElement>('.gfield.launch_deadline input:checked')?.value || 'na';
                const input_area = getInputValue(step, '.gfield.area');
                const input_budget = getInputValue(step, '.gfield.budget');
                const input_postal_code = getInputValue(step, '.gfield.postal_code');
                window.dataLayer.push({
                    'event': 'Etape3',
                    'phase': input_phase,
                    'delaiLancement': input_launch_deadline,
                    'superficie': input_area,
                    'budget': input_budget,
                    'codePostal': input_postal_code
                });
            }
        });

        // Click submit buttons.
        const submitButton = step.querySelector('[data-submission-type="submit"]');
        submitButton?.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];

            if (stepNumber === '4') {
                const input_company_size = step.querySelector<HTMLInputElement>('.gfield.company_size input:checked')?.value || 'na';
                window.dataLayer.push({
                    'event': 'Etape4',
                    'tailleEntreprise': input_company_size
                });
            }
        });
    });
};

const getInputValue = (step: HTMLElement, selector: string): string => {
    return step.querySelector<HTMLElement>(selector)?.querySelector<HTMLInputElement>('input')?.value?.trim() || 'na';
};
